import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postLogin } from "./api";

import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  loginRequest,
} from "./reducer";
import { profileSuccess } from "../profile/reducer";
//import {ROL_IDS} from "../../../Components/constants/user";

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    
    dispatch(loginRequest());
    const response = await postLogin({
      document: user.document,
      password: user.password,
    });

    const userData = response.data && response.data.id ? response.data : response;

   /* const isAdmin = userData.roles && userData.roles.find((rol: any) => rol.id === ROL_IDS.ADMIN);

    if (!isAdmin) {
      dispatch(apiError('No tienes permisos para acceder a esta aplicación'));
      return;
    }*/

    if (userData) {
      localStorage.setItem("authUser", JSON.stringify(userData));

      dispatch(profileSuccess({ data: userData, status: "success" }));
      dispatch(loginSuccess(userData));

      history("/dashboard");
      
    } else {
      dispatch(apiError('La respuesta de la API no tiene el formato esperado.'));
    }
  } catch (error: any) {
    console.error("Login error:", error);
    const message = error.response?.data?.message || 'Usuario o contraseña incorrectos';
    dispatch(apiError(message));
  }
};

export const logoutUser = () => async (dispatch: any ) => {
  try {
    // 1. Limpiar completamente localStorage
    localStorage.clear();
    
    // 2. Limpiar completamente sessionStorage
    sessionStorage.clear();

    // 3. Reiniciar estado de Redux a valores iniciales
    // const state = getState();
    // const store = configureStore({ reducer: rootReducer, devTools: true });
    
    // 4. Firebase logout si aplica
    let fireBaseBackend: any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }
    
    // 5. Forzar recarga de página para limpiar estado completamente
    setTimeout(() => {
      window.location.href = '/login';
    }, 100);
    
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin =
    (type: any, history: any) => async (dispatch: any) => {
      try {
        let response;

        if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
          const fireBaseBackend: any = getFirebaseBackend();
          response = fireBaseBackend.socialLoginUser(type);
        }
        const socialdata = await response;
        if (socialdata) {
          sessionStorage.setItem("authUser", JSON.stringify(response));
          dispatch(loginSuccess(response));
          history("/dashboard");
        }
      } catch (error) {
        dispatch(apiError(error));
      }
    };

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    return dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error));
  }
};
